var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "main-row pt-2 mb-12", attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-12", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "auto" } }, [
                    _c("img", {
                      staticClass: "arrow px-4 py-3",
                      attrs: { src: _vm.ic_back, id: "back-btn" },
                      on: { click: _vm.goBack },
                    }),
                  ]),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v("Back to Spot Market "),
                      ]),
                    ]
                  ),
                  _c("v-spacer"),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "px-16", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("label", { staticClass: "page-header-lbl" }, [
                              _vm._v("Shipment Bid"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-n2" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "bid-text-txt" }, [
                                _vm._v("Opportunity"),
                              ]),
                              _c("label", { staticClass: "bid-number-txt" }, [
                                _vm._v(" #" + _vm._s(_vm.bidNumber)),
                              ]),
                              _c("img", {
                                staticClass: "abs ml-2 copy mt-1",
                                attrs: {
                                  src: _vm.ic_copy,
                                  title: "Copy to Clipboard",
                                },
                                on: { click: _vm.copyToClipboard },
                              }),
                              _vm._v("   "),
                              _vm.lgAndUp
                                ? _c("img", {
                                    staticClass: "ml-8 separator",
                                    attrs: { src: _vm.ic_gray_dot_seperator },
                                  })
                                : _vm._e(),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "in-progress-chip mx-1 mt-n1",
                                  class: {
                                    "ml-14": _vm.lgAndUp,
                                    "ml-6": _vm.mdAndDown,
                                  },
                                  attrs: {
                                    color: _vm.statusColor(_vm.bidStatus),
                                    "text-color": _vm.statusTextColor(
                                      _vm.bidStatus
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.bidStatus))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-10" },
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("label", { staticClass: "select-offer" }, [
                              _vm._v("Select an offer"),
                            ]),
                          ]),
                          _c(
                            "v-col",
                            {
                              staticClass: "ml-n2 offers-wrap",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("div", { staticClass: "offers-badge" }, [
                                _vm._v(_vm._s(_vm.offersAmount)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-n2" },
                        [
                          _c("v-col", { attrs: { cols: "auto" } }, [
                            _c("label", { staticClass: "simple-text" }, [
                              _vm._v(
                                "Please choose one carrier to move the shipment."
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        _vm._l(_vm.carriersParticipating, function (carrier) {
                          return _c(
                            "v-col",
                            { key: carrier.id, attrs: { cols: "10" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "offer-card",
                                  class: {
                                    active:
                                      _vm.selectedCarrierOption == carrier.id,
                                  },
                                  attrs: { elevation: "0", ripple: false },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectedCarrierOption = carrier.id
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-6 mt-3",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "auto" } },
                                                [
                                                  _vm.noResponse(carrier)
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "in-progress-chip mx-1 mt-n1",
                                                          attrs: {
                                                            color: "#ffdbe2",
                                                            "text-color":
                                                              "#f6123a",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Bid in Progress"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  !_vm.noResponse(carrier)
                                                    ? _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "card-status",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.carrierOptionStatus(
                                                                carrier
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.showRetractOfferBtn(
                                                    carrier
                                                  )
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "in-progress-chip mx-1 mt-n1 awarded-chip",
                                                          class: {
                                                            "ml-4":
                                                              _vm.noResponse(
                                                                carrier
                                                              ),
                                                          },
                                                          attrs: {
                                                            color: "#6639C2",
                                                            "text-color":
                                                              "#f0f0f0",
                                                          },
                                                        },
                                                        [_vm._v("Awarded")]
                                                      )
                                                    : _vm._e(),
                                                  _c("v-spacer"),
                                                  _vm.showAwardCarrierBtn(
                                                    carrier
                                                  )
                                                    ? _c("smart-btn", {
                                                        staticClass: "mt-2",
                                                        attrs: {
                                                          type: "primary",
                                                          label:
                                                            "Award Carrier",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.award(
                                                              carrier
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.showAwardAndTenderBtn(
                                                    carrier
                                                  )
                                                    ? _c("smart-btn", {
                                                        staticClass: "mt-2",
                                                        attrs: {
                                                          type: "primary",
                                                          label:
                                                            "Award & Tender to Brokerage",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.awardAndTenderToBrokerage(
                                                              carrier
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.showRetractOfferBtn(
                                                    carrier
                                                  )
                                                    ? _c("smart-btn", {
                                                        staticClass: "mt-2",
                                                        attrs: {
                                                          type: "danger",
                                                          label:
                                                            "retract offer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.displayConfirmRetract = true
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c("v-spacer"),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "mx-3",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    attrs: {
                                                      src: _vm.logo(
                                                        carrier.carrierName
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "mx-3",
                                                  attrs: { cols: "2" },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "carrier-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.carrierName(
                                                            carrier.carrierName
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "carrier-scac",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(carrier.scac)
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "mx-3",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "text-minor",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Carrier Offer amount"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "card-text-value",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          carrier.offerAmount
                                                            ? "$" +
                                                                _vm.formatMoney(
                                                                  carrier.offerAmount
                                                                ) +
                                                                " USD"
                                                            : "N/A"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "mx-3",
                                                  attrs: { cols: "auto" },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "text-minor",
                                                    },
                                                    [_vm._v("Response Date")]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "card-text-value response-date",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            carrier.responseDate
                                                              ? _vm.formatDate(
                                                                  carrier.responseDate
                                                                )
                                                              : "N/A"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "mt-8" },
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "label",
                                      { staticClass: "shipment-route" },
                                      [_vm._v("Shipment Route")]
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n4",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "stops-number" },
                                        [_vm._v("2 stops, 1 delivery ")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n2",
                                      attrs: {
                                        xl: "11",
                                        lg: "12",
                                        md: "12",
                                        sm: "12",
                                        xs: "12",
                                      },
                                    },
                                    [
                                      _c("v-divider", {
                                        staticClass: "my-3",
                                        attrs: { inset: "" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "mt-3" },
                                [
                                  _c("v-col", { attrs: { cols: "auto" } }, [
                                    _c("img", {
                                      staticClass: "ml-n1",
                                      attrs: { src: _vm.ic_dot },
                                    }),
                                    _c("br"),
                                    _c("img", {
                                      staticClass: "mt-1",
                                      attrs: { src: _vm.ic_border },
                                    }),
                                    _c("br"),
                                    _c("img", {
                                      staticClass: "mt-n6",
                                      attrs: { src: _vm.ic_dot_blue },
                                    }),
                                  ]),
                                  _vm.order
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "stop-head",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.orig.city +
                                                            ", " +
                                                            _vm.orig.state +
                                                            " " +
                                                            _vm.orig
                                                              .postalCode +
                                                            " " +
                                                            _vm.orig.country
                                                        ) + " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n6" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    { staticClass: "stop-sub" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.orig.companyName +
                                                            ", " +
                                                            _vm.orig.address1
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-128" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "stop-head",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dest.city +
                                                            ", " +
                                                            _vm.dest.state +
                                                            " " +
                                                            _vm.dest
                                                              .postalCode +
                                                            " " +
                                                            _vm.dest.country
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { staticClass: "mt-n6" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "label",
                                                    { staticClass: "stop-sub" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dest.companyName +
                                                            ", " +
                                                            _vm.dest.address1
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { attrs: { cols: "auto" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "flat-card mt-12",
                                  attrs: { elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "auto" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "target-rate-lbl" },
                                          [_vm._v("Target Rate")]
                                        ),
                                      ]),
                                      _c("v-spacer"),
                                      _c("v-col", { attrs: { cols: "auto" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "target-rate-lbl" },
                                          [_vm._v(_vm._s(_vm.targetRate))]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "mt-3" }),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-2" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pl-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("smart-countdown-timer", {
                                            attrs: {
                                              endDate: _vm.endDateComputed,
                                              "more-space-between-cards": true,
                                              noGaps: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-spacer"),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-8" },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n2",
                              attrs: {
                                xl: "11",
                                lg: "12",
                                md: "12",
                                sm: "12",
                                xs: "12",
                              },
                            },
                            [
                              _c("v-divider", {
                                staticClass: "my-3",
                                attrs: { inset: "" },
                              }),
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("label", { staticClass: "shipment-route" }, [
                              _vm._v("Shipment Information"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Client")]
                                        ),
                                      ]),
                                      _vm.account
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "grid-val" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.account.company)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Container Type")]
                                        ),
                                      ]),
                                      _vm.container
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "grid-val" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.container.description
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "7",
                                            lg: "7",
                                            md: "7",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-head" },
                                            [_vm._v("Class")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "5",
                                            lg: "5",
                                            md: "5",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-val" },
                                            [_vm._v("50")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Weight per Piece")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.weightPerPiece) + " lb"
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Number of Pieces")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [_vm._v(_vm._s(_vm.numberOfPieces))]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "7",
                                            lg: "7",
                                            md: "7",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-head" },
                                            [_vm._v("Total Weight")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "5",
                                            lg: "5",
                                            md: "5",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-val" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.totalWeight) + " lb"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Length")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [_vm._v(_vm._s(_vm.length) + " in")]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Width")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [_vm._v(_vm._s(_vm.width) + " in")]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "7",
                                            lg: "7",
                                            md: "7",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-head" },
                                            [_vm._v("Height")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "5",
                                            lg: "5",
                                            md: "5",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-val" },
                                            [_vm._v(_vm._s(_vm.height) + " in")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Equipment Type")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [_vm._v("Flat Bed")]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-head" },
                                          [_vm._v("Reference Number")]
                                        ),
                                      ]),
                                      _c("v-col", { attrs: { cols: "6" } }, [
                                        _c(
                                          "label",
                                          { staticClass: "grid-val" },
                                          [_vm._v(_vm._s(_vm.referenceNumber))]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xl: "3",
                                    lg: "3",
                                    md: "3",
                                    sm: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "7",
                                            lg: "7",
                                            md: "7",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-head" },
                                            [_vm._v("Hazardous Material")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            xl: "5",
                                            lg: "5",
                                            md: "5",
                                            sm: "6",
                                            xs: "6",
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "grid-val" },
                                            [_vm._v("None")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-n2",
                                  attrs: {
                                    xl: "11",
                                    lg: "12",
                                    md: "12",
                                    sm: "12",
                                    xs: "12",
                                  },
                                },
                                [
                                  _c("v-divider", {
                                    staticClass: "my-3",
                                    attrs: { inset: "" },
                                  }),
                                ],
                                1
                              ),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("label", { staticClass: "shipment-route" }, [
                                  _vm._v("Estimated Pickup"),
                                ]),
                              ]),
                              _vm.order
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("label", { staticClass: "time-lbl" }, [
                                        _vm._v(_vm._s(_vm.estimatedPickup)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.order
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mt-n2",
                                  attrs: {
                                    xl: "11",
                                    lg: "12",
                                    md: "12",
                                    sm: "12",
                                    xs: "12",
                                  },
                                },
                                [
                                  _c("v-divider", {
                                    staticClass: "my-3",
                                    attrs: { inset: "" },
                                  }),
                                ],
                                1
                              ),
                              _c("v-col", { attrs: { cols: "12" } }, [
                                _c("label", { staticClass: "shipment-route" }, [
                                  _vm._v("Estimated Drop Off "),
                                ]),
                              ]),
                              _vm.order
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "mt-n2",
                                      attrs: { cols: "12" },
                                    },
                                    [
                                      _c("label", { staticClass: "time-lbl" }, [
                                        _vm._v(_vm._s(_vm.estimatedDelivery)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n2",
                              attrs: {
                                xl: "11",
                                lg: "12",
                                md: "12",
                                sm: "12",
                                xs: "12",
                              },
                            },
                            [
                              _c("v-divider", {
                                staticClass: "my-3",
                                attrs: { inset: "" },
                              }),
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("label", { staticClass: "shipment-route" }, [
                              _vm._v("Comments"),
                            ]),
                          ]),
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n2",
                              attrs: {
                                xl: "8",
                                lg: "8",
                                md: "10",
                                sm: "12",
                                xs: "12",
                              },
                            },
                            [
                              _c("smart-textarea", {
                                attrs: {
                                  maxlength: "255",
                                  label: "Provide your comment here..",
                                },
                                model: {
                                  value: _vm.comments,
                                  callback: function ($$v) {
                                    _vm.comments = $$v
                                  },
                                  expression: "comments",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n2",
                              attrs: {
                                xl: "11",
                                lg: "12",
                                md: "12",
                                sm: "12",
                                xs: "12",
                              },
                            },
                            [
                              _c("v-divider", {
                                staticClass: "my-3",
                                attrs: { inset: "" },
                              }),
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("label", { staticClass: "shipment-route" }, [
                              _vm._v("Map"),
                            ]),
                          ]),
                          _c(
                            "v-col",
                            {
                              staticClass: "mt-n2",
                              attrs: {
                                xl: "11",
                                lg: "12",
                                md: "12",
                                sm: "12",
                                xs: "12",
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "mapSrc br-10",
                                attrs: { src: _vm.mapUrl },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-snackbar",
                {
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
              ),
              _c("confirm-retract-offer", {
                attrs: {
                  display: _vm.displayConfirmRetract,
                  retracting: _vm.retracting,
                },
                on: {
                  hide: function ($event) {
                    _vm.displayConfirmRetract = false
                  },
                  retract: _vm.retractOffer,
                },
              }),
              _c("save-shipment-errors", {
                attrs: {
                  display: _vm.showSaveShipmentServerErrorsPopup,
                  error: _vm.saveShipmentServerErrors,
                },
                on: {
                  hide: function ($event) {
                    _vm.showSaveShipmentServerErrorsPopup = false
                  },
                },
              }),
              _c(
                "v-overlay",
                {
                  attrs: {
                    value: _vm.showLoadingScreen,
                    opacity: "0.9",
                    color: "#fff",
                  },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-n16" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          class: { "px-6": _vm.smAndDown },
                        },
                        [
                          _c("img", {
                            staticClass: "rotating",
                            attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                          }),
                          _c("p", {
                            staticClass: "overlay-txt mt-5",
                            domProps: {
                              innerHTML: _vm._s(_vm.loadingScreenMessage),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }